/**
 * Extrai uma mensagem de erro legível de um `catch (err)` tipado como
 * `unknown` — substitui o padrão antigo `catch (err: any) { err.message }`
 * (feature 073, redução de `any`). Retorna `null` quando não há mensagem
 * utilizável, para compor com um fallback (`getErrorMessage(err) || t(...)`),
 * preservando o comportamento de `err.message || fallback` de antes.
 */
export function getErrorMessage(err: unknown): string | null {
  if (err instanceof Error && err.message.trim()) {
    return err.message;
  }
  if (err && typeof err === 'object' && 'message' in err) {
    const message = (err as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }
  return null;
}
